import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { TaskListComponent } from './task-list/task-list.component';
import { TaskReportComponent } from './task-report/task-report.component';
import { AllTaskReportComponent } from './all-task-report/all-task-report.component';
import { TaskEntryComponent } from './task-entry/task-entry.component';

const routes: Routes = [
  { path: 'TaskDetail', component: TaskDetailComponent },
  { path: 'Tasks', component: TaskListComponent },
  { path: 'TaskRpt', component: TaskReportComponent },
  { path: 'RptOrgTasks', component: AllTaskReportComponent },
  { path: 'TaskEntry', component: TaskEntryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TasksRoutingModule { }
